// src/components/Navbar/Navbar.jsx

import React, { useState, useEffect } from 'react';
import { Link as RouterLink, NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logout } from 'features/user';

//import wonderMissionLogo from 'assets/wonder_mission_logo.png';
// import wonderMissionLogo from './assets/ALPHA_wm_cw-104.png';
import wonderMissionLogo from './assets/logo.png';

import { Navigate } from 'react-router-dom';





// Material-UI components used directly in JSX
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';




// Import all styled components and colors from the dedicated style file
import {
    colors,
    StyledAppBar,
    NavbarContentBox,
    StyledLogoContainer,
    StyledMenuIconButton,
    StyledBox,
    StyledCloseIcon,
    StyledDrawer,
    StyledListItem,
} from './Navbar.styles';

// NEW: Import the DesktopNavLinks component
import DesktopNavLinks from './DesktopNavLinks'; // Adjust path as needed



import CountdownTimerNavbar from './components/countdown/CountdownTimerNavbar'






// --- NAVBAR COMPONENT: ACCEPTS initialPermanent PROP ---
const Navbar = ({ initialPermanent = false }) => { // Default to false (fade-in) if not provided




    const { isAuthenticated } = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();






    // 2. Updated function to handle both navigation and scrolling
    const handleNavigateAndScroll = (url) => {
        console.log('click and scroll');

        // --- SCROLL TO TOP LOGIC ---
        // Check if the ref is attached and has a scroll method (for a scrollable container)
        // OR, more reliably for the entire window/document:
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: Makes the scroll smooth
        });

        // If the main div (pageRef.current) is the scrollable container, use this instead:
        // if (pageRef.current) {
        //     pageRef.current.scrollTo({
        //         top: 0,
        //         behavior: 'smooth'
        //     });
        // }
        // -----------------------------

        // 3. Perform the navigation after the scroll
        if (url) {
            // Use a short delay if scrolling the pageRef container to allow the DOM to update,
            // but for window.scrollTo, it's usually fine to run immediately.
            navigate(url);
        }
    };




























    const [mobileOpen, setMobileOpen] = useState(false);
    // Renamed for clarity: tracks actual scroll position relative to threshold
    const [scrolledActual, setScrolledActual] = useState(false);

    const scrollThreshold = 100;

    useEffect(() => {
        // Only attach scroll listener if the navbar is NOT set to be permanent
        if (!initialPermanent) {
            const handleScroll = () => {
                if (window.scrollY > scrollThreshold) {
                    setScrolledActual(true);
                } else {
                    setScrolledActual(false);
                }
            };

            window.addEventListener('scroll', handleScroll);

            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
        // If initialPermanent is true, the effect won't run, and scrolledActual will remain false.
        // This is fine because isNavbarEffectivelyVisible will use initialPermanent.
    }, [initialPermanent, scrollThreshold]); // Depend on initialPermanent to re-run effect if it changes

    // --- NEW: Derive the effective state for the Navbar's visibility ---
    // The Navbar is effectively visible if it's set to be permanent, OR if the user has scrolled.
    const isNavbarEffectivelyVisible = initialPermanent || scrolledActual;


    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const baseMenuCategories = [
        { label: 'Home', url: '/', navLabel: 'Home' },
        // { label: 'Site Map', url: '/sitemap', navLabel: 'Site Map' },
        { label: 'Donate', url: '/donate', navLabel: 'Donate' },
        { label: 'Contact', url: '/contact', navLabel: 'Contact' },
        { label: 'About', url: '/about', navLabel: 'About' },
    ];

    const baseMenuCategoriesDrawer = [
        { label: 'Home', url: '/', navLabel: 'Home' },
        // { label: 'Site Map', url: '/sitemap', navLabel: 'Site Map' },
        { label: 'Donate', url: '/donate', navLabel: 'Donate' },
        { label: 'Contact', url: '/contact', navLabel: 'Contact' },
        { label: 'About', url: '/about', navLabel: 'About' },
        // { url: '/friendsofgoddard', navLabel: 'Friends of Goddard' },
        // { url: '/awordfromcharles', navLabel: 'About Our Founder' },
    ];


    const menuCategories_ORIG = isAuthenticated
        ? [...baseMenuCategories, { label: 'Logout', url: '/login', navLabel: 'Logout' }]
        : [...baseMenuCategories, { label: 'Login', url: '/login', navLabel: 'Login' }];


    const menuCategories = isAuthenticated
        ? [...baseMenuCategories]
        : [...baseMenuCategories];

    const menuCategoriesDrawer = isAuthenticated
        ? [...baseMenuCategoriesDrawer]
        : [...baseMenuCategoriesDrawer];


    function clearCookies() {
        document.cookie.split(';').forEach(cookie => {
            document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
        });
    }

    const handleClick = (textArg) => {
        if (textArg.label === 'Logout') {
            console.log('Logging out...');
            clearCookies();
            dispatch(logout());
            navigate('/login');
        } else {
            navigate(textArg.url);
        }
        setMobileOpen(false);
    };





    return (
        <div>
            {/* Pass the derived visibility state (isNavbarEffectivelyVisible) to StyledAppBar */}
            <StyledAppBar position="fixed" scrolled={isNavbarEffectivelyVisible}>
                <NavbarContentBox>
                    {/* Logo Link */}
                    {/* <RouterLink to="/" style={{ textDecoration: 'none' }}> */}
                    <StyledLogoContainer>
                        <img
                            src={wonderMissionLogo}
                            onClick={() => handleNavigateAndScroll('/')}
                            alt="Wonder Mission Logo"
                            style={{
                                // backgroundColor:'green', 
                                height: '3rem',
                                padding: '0rem',
                                paddingBottom: '0.5rem',
                                margin: '0rem',
                                width: 'auto',
                                display: 'block'
                            }}
                        />
                    </StyledLogoContainer>
                    {/* </RouterLink> */}



                    {/* <CountdownTimerNavbar></CountdownTimerNavbar> */}

                    {/* Desktop Links */}
                    <DesktopNavLinks menuCategories={menuCategories} handleClick={handleClick} />

                    {/* Mobile Menu Icon */}
                    <Box
                        sx={{
                            display: { xs: 'block', md: 'none' }
                        }}
                    >
                        <StyledMenuIconButton onClick={handleDrawerToggle} edge="end">
                            <MenuIcon sx={{ marginRight: '1rem', width: '2rem', height: '2rem' }} />
                        </StyledMenuIconButton>
                    </Box>
                </NavbarContentBox>
            </StyledAppBar>

            {/* Mobile Drawer */}
            <nav>
                <StyledDrawer
                    anchor="left"
                    // Use the derived visibility state for drawer opening
                    open={mobileOpen && isNavbarEffectivelyVisible}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true,
                    }}
                >
                    <StyledBox>
                        <IconButton onClick={handleDrawerToggle} sx={{ margin: '10px 0' }}>
                            <StyledCloseIcon />
                        </IconButton>
                        <List sx={{ width: '100%', textAlign: 'center' }}>
                            {menuCategoriesDrawer.map((item) => (
                                <StyledListItem key={item.label}>
                                    <Button
                                        onClick={() => handleClick(item)}
                                        sx={{
                                            fontSize: '1.2rem',
                                            color: colors.textColor,
                                            width: '100%',
                                            '&:hover': { color: colors.accentColor, backgroundColor: 'rgba(255,255,255,0.1)' }
                                        }}
                                    >
                                        {item.navLabel}
                                    </Button>
                                </StyledListItem>
                            ))}
                        </List>
                    </StyledBox>
                </StyledDrawer>
            </nav>
        </div>
    );
};

export default Navbar;